<template>
  <button 
    class="btn mb-0" 
    :class="[getClasses(variant, color, size, fullWidth), { 'disabled': loading || disabled }]" 
    @click="handleClick"
    :disabled="loading || disabled"
    :style="{ cursor: (loading || disabled) ? 'not-allowed' : 'pointer' }"
    type="button"
  >
    <span 
      v-if="loading" 
      class="spinner-border spinner-border-sm me-2" 
      role="status" 
      aria-hidden="true"
    ></span>
    <slot />
  </button>
</template>

<script>
export default {
  name: 'argon-button',
  /*
   * Sans cette déclaration, Vue considère `click` comme un attribut à
   * répercuter : le listener du parent s'attache AUSSI nativement au
   * <button>, en plus de handleClick qui le réémet. Chaque clic déclenchait
   * donc la méthode deux fois — d'où le toast affiché en double.
   */
  emits: ['click'],
  props: {
    color: {
      type: String,
      default: 'info'
    },
    size: {
      type: String,
      default: 'mdlg'
    },
    variant: {
      type: String,
      default: 'fill'
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getClasses(variant, color, size, fullWidth) {
      let colorValue = ''
      let sizeValue = ''
      let fullWidthValue = ''

      if (variant === 'gradient') {
        colorValue = `bg-gradient-${color}`
      } else if (variant === 'outline') {
        colorValue = `btn-outline-${color}`
      } else {
        colorValue = `btn-${color}`
      }

      sizeValue = size ? `btn-${size}` : ''
      fullWidthValue = fullWidth ? 'w-100' : ''

      return `${colorValue} ${sizeValue} ${fullWidthValue}`.trim()
    },
    
    handleClick(event) {
      if (this.loading || this.disabled) {
        event.preventDefault()
        event.stopPropagation()
        return false
      }
      
      this.$emit('click', event)
    }
  }
}
</script>

<style scoped>
.btn.disabled {
  opacity: 0.6;
  pointer-events: none;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed !important;
}
</style>
